if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){
			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

        updateCartQtyItems(updates){
          let alert = null;

          this.form.classList.add('processing');
          if ( this.querySelector('.alert') ) {
              this.querySelector('.alert').remove();
          }
          
          fetch(KROWN.settings.routes.cart_update_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body: JSON.stringify({ updates })
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
        }
		updateCartQtyFunc(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});
                  
                   if (document.querySelector(".cart-form__add-on-products")){
            		  const addOnProductsHTML = sectionInnerHTML.querySelector('.cart-form__add-on-products').innerHTML;  
                      document.querySelector('.cart-form__add-on-products').innerHTML = addOnProductsHTML;
                    }
                      
        			if ( document.querySelector('cart-recommendations') ) {
        				document.querySelector('cart-recommendations').innerHTML = '';
        				document.querySelector('cart-recommendations').generateRecommendations();
        			}

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

		addTocart(id, quantity) {

			let alert = '';

			const body = JSON.stringify({
				id,
				quantity
			});

			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				},
				body
			})
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.className = 'alert alert--error';
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						if ( this.cartType == 'page' ) {
							if ( document.getElementById('product-page-form-error-cart-alert') ) {
								document.getElementById('product-page-form-error-cart-alert').remove();
							}
							alert.style.marginTop = '1em';
							alert.style.marginBottom = '0';
							alert.id = 'product-page-form-error-cart-alert';
							this.form.parentElement.append(alert);
							return false;
						}
						return fetch('?section_id=helper-cart');
					} else {
						if ( this.cartType == 'page' ) {
							document.location.href = KROWN.settings.routes.cart_url;
							return false;
						} else {
							return fetch('?section_id=helper-cart');
						}
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
					});

                  
                   if (document.querySelector(".cart-form__add-on-products")){
            		  const addOnProductsHTML = sectionInnerHTML.querySelector('.cart-form__add-on-products').innerHTML;  
                      document.querySelector('.cart-form__add-on-products').innerHTML = addOnProductsHTML;
                    }
                      
        			if ( document.querySelector('cart-recommendations') ) {
        				document.querySelector('cart-recommendations').innerHTML = '';
        				document.querySelector('cart-recommendations').generateRecommendations();
        			}
				})
				.catch(e => {
					console.log(e);
				})
		}

		updateCartQty(item, newQty){

			if (!localStorage.getItem('gift-box-removed')) {
				KROWN.cart_count = parseInt(KROWN.cart_count) - parseInt(item.dataset.qty) + newQty;
			}

			console.log('KROWN.cart_count updateCartQty', KROWN.cart_count)

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

            let cart_items = []

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
                    cart_items = response.items
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

                  
                   if (document.querySelector(".cart-form__add-on-products")){
            		  const addOnProductsHTML = sectionInnerHTML.querySelector('.cart-form__add-on-products').innerHTML;  
                      document.querySelector('.cart-form__add-on-products').innerHTML = addOnProductsHTML;
                    }
                      
        			if ( document.querySelector('cart-recommendations') ) {
        				document.querySelector('cart-recommendations').innerHTML = '';
        				document.querySelector('cart-recommendations').generateRecommendations();
        			}
                  
					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
                    if(newQty == 0){
                      let updates = {}
                      cart_items.forEach(cart_item => {
                        if(cart_item.properties && cart_item.properties["_lb-product"] && cart_item.properties["_lb-product"].includes(item.dataset.productId)){
                          updates[cart_item.id] = 0
                        }
                      })
                      if(Object.keys(updates).length > 0){
                        this.updateCartQtyItems(updates);
                      }
                    }
					this.form.classList.remove('processing');

					let cartCountLessPackage = ''
					const ecoPackagingItem = document.querySelector('.cart-item--eco-packaging');
					const giftWrappingItem = document.querySelector('.cart-item--gift-wrapping');


					if ( ecoPackagingItem || giftWrappingItem ) cartCountLessPackage = KROWN.cart_count - 1;

					console.log('cartCountLessPackage updateQty', cartCountLessPackage)

					if(ecoPackagingItem && cartCountLessPackage <= 0) {
						console.log('remove Eco Packing')
						KROWN.cart_count = 0;
						this.updateCartQtyFunc(ecoPackagingItem, 0)
					}
					else if(giftWrappingItem && cartCountLessPackage <= 0) {
						console.log('remove Gift Wrapping')
						if (localStorage.getItem('gift-box-removed')) {
							localStorage.removeItem('gift-box-removed');
						}
						document.querySelectorAll('[data-js-cart-wrapping-checkbox]').forEach((checkbox) => {
							checkbox.checked = false;
						});
						KROWN.cart_count = 0;
						this.updateCartQtyFunc(giftWrappingItem, 0)
					}

					if(localStorage.getItem('gift-box-removed')) {
						console.log('add Eco Packing')
						console.log('KROWN.cart_count add Eco Packing', KROWN.cart_count);
						localStorage.removeItem('gift-box-removed');
						this.addTocart(KROWN.eco_packaging_product.variant_id, 1)
					}
				});
		}

	}


  	if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {
	window.refreshCart = () => {

		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {
			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;              
			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();
			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})

			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

            if (document.querySelector(".cart-form__add-on-products")){
    		  const addOnProductsHTML = sectionInnerHTML.querySelector('.cart-form__add-on-products').innerHTML;  
              document.querySelector('.cart-form__add-on-products').innerHTML = addOnProductsHTML;
            }
              
			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})
	}
  

}


function custAddTocart(id, quantity) {
			let alert = '';

			const body = JSON.stringify({
				id,
				quantity
			});

			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				},
				body
			})
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.className = 'alert alert--error';
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						return fetch('?section_id=helper-cart');
                        window.refreshCart();
					} else {
                        return fetch('?section_id=helper-cart');
						
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					if ( alert != '' ) {
						document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
					}

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
					});

                   if (document.querySelector(".cart-form__add-on-products")){
            		  const addOnProductsHTML = sectionInnerHTML.querySelector('.cart-form__add-on-products').innerHTML;  
                      document.querySelector('.cart-form__add-on-products').innerHTML = addOnProductsHTML;
                    }
                      
        			if ( document.querySelector('cart-recommendations') ) {
        				document.querySelector('cart-recommendations').innerHTML = '';
        				document.querySelector('cart-recommendations').generateRecommendations();
        			}
				})
				.catch(e => {
					console.log(e);
				})
		}
document.addEventListener('cart:refresh', ()=>{
  window.refreshCart();
})
document.addEventListener('click', function (e) {
  const textarea_container = document.querySelector('.textarea_container');
  const overlay = document.querySelector('.textarea-overlay');
  if (e.target.classList.contains('textarea-overlay') || e.target.classList.contains('site-overlay') || e.target.closest(".save-button")) {
    if(!e.target.closest(".save-button") && textarea_container){
      textarea_container.querySelector("#cartSpecialInstructions").value = ""
    }
    textarea_container.classList.remove('active');
    overlay.classList.remove('active');
  }
  const Elem = e.target.closest('.add_order_note');
  if (Elem && textarea_container) {
    textarea_container.classList.toggle('active');
    overlay.classList.add('active');
  }


  const targetEle = e.target;
  if(targetEle.classList.contains("add-to-cart") && targetEle.classList.contains("button")){
    const variantEle = targetEle.closest("[data-variant-id]");
    if(variantEle){
      custAddTocart(variantEle.dataset.variantId, 1)
    }
  }
});

